const path = 'https://www.wooclap.com/images/favicons/';

export const seoIconsLinks = [
  {
    href: `${path}apple-icon-57x57.png`,
    rel: 'apple-touch-icon',
    sizes: '57x57',
    type: 'image/png',
  },
  {
    href: `${path}apple-icon-60x60.png`,
    rel: 'apple-touch-icon',
    sizes: '60x60',
    type: 'image/png',
  },
  {
    href: `${path}apple-icon-72x72.png`,
    rel: 'apple-touch-icon',
    sizes: '72x72',
    type: 'image/png',
  },
  {
    href: `${path}apple-icon-76x76.png`,
    rel: 'apple-touch-icon',
    sizes: '76x76',
    type: 'image/png',
  },
  {
    href: `${path}apple-icon-114x114.png`,
    rel: 'apple-touch-icon',
    sizes: '114x114',
    type: 'image/png',
  },
  {
    href: `${path}apple-icon-120x120.png`,
    rel: 'apple-touch-icon',
    sizes: '120x120',
    type: 'image/png',
  },
  {
    href: `${path}apple-icon-144x144.png`,
    rel: 'apple-touch-icon',
    sizes: '144x144',
    type: 'image/png',
  },
  {
    href: `${path}apple-icon-152x152.png`,
    rel: 'apple-touch-icon',
    sizes: '152x152',
    type: 'image/png',
  },
  {
    href: `${path}apple-icon-180x180.png`,
    rel: 'apple-touch-icon',
    sizes: '180x180',
    type: 'image/png',
  },
  {
    href: `${path}android-icon-36x36.png`,
    rel: 'icon',
    sizes: '36x36',
    type: 'image/png',
  },
  {
    href: `${path}android-icon-48x48.png`,
    rel: 'icon',
    sizes: '48x48',
    type: 'image/png',
  },
  {
    href: `${path}android-icon-72x72.png`,
    rel: 'icon',
    sizes: '72x72',
    type: 'image/png',
  },
  {
    href: `${path}android-icon-96x96.png`,
    rel: 'icon',
    sizes: '96x96',
    type: 'image/png',
  },
  {
    href: `${path}android-icon-144x144.png`,
    rel: 'icon',
    sizes: '144x144',
    type: 'image/png',
  },
  {
    href: `${path}android-icon-192x192.png`,
    rel: 'icon',
    sizes: '192x192',
    type: 'image/png',
  },
  {
    href: `${path}favicon-16x16.png`,
    rel: 'icon',
    sizes: '16x16',
    type: 'image/png',
  },
  {
    href: `${path}favicon-32x32.png`,
    rel: 'icon',
    sizes: '32x32',
    type: 'image/png',
  },
  {
    href: `${path}favicon-96x96.png`,
    rel: 'icon',
    sizes: '96x96',
    type: 'image/png',
  },
];
